import ReactDOM from 'react-dom/client'

import { App } from '@/app'

const rootElement = document.querySelector('#root')

if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)

    root.render(<App />)
}
